import { ToolBarContext } from '../components/ToolBar/ToolBarContext';
import { ControlProvider } from '../components/Link/ControlContext';
import { TabProvider } from '../components/Tabs/TabProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const TOOLBAR_CONTEXT_VALUE = {
  use: undefined
};
const TAB_STYLE_OVERRIDES = {};

/*
 * This "context" is used as a catch-all wrapper where we can reset any context that might
 * affect portaled components like modals and popovers
 */
export const ResetContext = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ToolBarContext.Provider, {
    value: TOOLBAR_CONTEXT_VALUE,
    children: /*#__PURE__*/_jsx(ControlProvider, {
      isControl: false,
      children: /*#__PURE__*/_jsx(TabProvider, {
        tabIconStyleOverrides: TAB_STYLE_OVERRIDES,
        tabLinkStyleOverrides: TAB_STYLE_OVERRIDES,
        children: children
      })
    })
  });
};